export default __webpack_public_path__ + "static/media/2.bf428a23.png";